import PropTypes from "prop-types";
import { Provider as StateProvider } from "react-redux";
import LocaleProvider from "../../components/LocaleProvider";
import { Switch } from "react-router-dom";
import ErrorBoundary from "../ErrorBoundary";
import routes from "../../routes";
import { FeaturesProvider } from "../Features";

const App = ({
  store,
  translations,
  history,
  RouterComponent,
  location,
  experiments
}) => {
  const routerProps = CLIENT ? { history } : { location };

  return (
    <FeaturesProvider experiments={experiments}>
      <StateProvider store={store}>
        <LocaleProvider translations={translations}>
          <ErrorBoundary>
            <RouterComponent {...routerProps}>
              <Switch>{routes}</Switch>
            </RouterComponent>
          </ErrorBoundary>
        </LocaleProvider>
      </StateProvider>
    </FeaturesProvider>
  );
};

App.propTypes = {
  store: PropTypes.object.isRequired,
  translations: PropTypes.object.isRequired,
  RouterComponent: PropTypes.any.isRequired,
  history: PropTypes.object,
  location: PropTypes.string,
  experiments: PropTypes.object
};

export default App;
